import {stringify, _, React, observer, observable, computed, IDisposer, action, useLocalStore, useEffect, useLayoutEffect, classNames, useAsObservableSource, autorun, useIntersectionObserver} from '@api'
import {AssortmentCardStore, AssortmentCardStoreContext, CatalogItemsPanel, RootGroups, useAssortmentCardStore, useVipLocalStore, VipLocalStore} from '@modules'
import {StoresInstance} from '@stores'
import {when} from 'mobx'
import * as css from './AssortmentCardDetailsPanel.css'

/// region Store

export class AssortmentCardDetailsPanelStore extends VipLocalStore {
  constructor(stores: StoresInstance, public props: Omit<MyProps, 'className'> & {card: AssortmentCardStore}) {
    super(stores)
  }

  registerEffects = () => {
    const _toDispose: Array<IDisposer> = [
      when(() => !this.everExpanded && this.expanded, () => this.everExpanded = true)
    ]

    return () => {
      _toDispose.forEach(d => d())
    }
  }

  @computed get queryVariablesEs() {
    const {catalog: {queryVariablesEs}, props: {card: {mustTerms}}} = this

    let r = _.cloneDeep(queryVariablesEs)
    r.query.bool.filter.push(..._.cloneDeep(mustTerms))
    return r
  }

  @observable everVisible = false
  @observable everExpanded = false
  get expanded() {
    return this.props.card.expanded
  }
}

export const AssortmentCardDetailsPanelStoreContext = React.createContext<AssortmentCardDetailsPanelStore>(null)
export const useAssortmentCardDetailsPanelStore = () => React.useContext(AssortmentCardDetailsPanelStoreContext)

/// endregion

/// region Components

interface MyProps {
  className?: string
}

export const AssortmentCardDetailsPanel = observer<MyProps>(function AssortmentCardDetailsPanel({className, ...props}) {
  const card = useAssortmentCardStore(),
    obsProps = useAsObservableSource({props, card}),
    store = useVipLocalStore((stores) => new AssortmentCardDetailsPanelStore(stores, obsProps)),
    {catalog: {isProductView, isGroupedView, settings: {assortment: {groupingBehavior}}}, everExpanded, props: {card: {count}}} = store,
    filteredOfflineItems = []

  const [entry, observerRef] = useIntersectionObserver()
  const everVisible = store.everVisible || entry.isIntersecting
  useLayoutEffect(() => { if (everVisible) store.everVisible = everVisible}, [everVisible])

  useEffect(() => store.registerEffects(), [])

  return (
    <AssortmentCardDetailsPanelStoreContext.Provider value={store}>
      <div
        className={classNames(css.root, className)}
        ref={observerRef}
        data-view={isProductView ? 'products' : 'groups'}
      >
        {!everExpanded || !everVisible ? null :
         ((isGroupedView && groupingBehavior === 'outside') || !isGroupedView) ?
         <CatalogItemsPanel
           queryKey={stringify(card.key)}
           onlineItemCount={!_.isNumber(count) ? null : count - filteredOfflineItems.length}
           offlineItemCount={filteredOfflineItems.length}
           queryVariables={store.queryVariablesEs}
         />
          : <RootGroups />}
      </div>
    </AssortmentCardDetailsPanelStoreContext.Provider>)
})

/// endregion




// WEBPACK FOOTER //
// ./src/modules/catalog/internal/gridList/components/groupBy/GroupByCatalog/Assortments/AssortmentCard/DetailsPanel/AssortmentCardDetailsPanel.tsx